/* eslint-disable no-eval */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-return-assign */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { TextInput, Tooltip } from '../../../canvasComponents/index';
import { FormattedMessage, IntlProvider, injectIntl } from 'react-intl';
import CustomTextFieldSettingsForm from './CustomTextField.settingsForm';
import './customTextField.scss';
import getLocalParams from '../localizationCustoms';

const CustomTextField = class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      // eslint-disable-next-line react/no-unused-state
      data: props.data,
    };
    this.setValue = this.setValue.bind(this);
  }

  componentDidMount() {
    const { state: { value }, props: { component: { useSessionStorage } } } = this;
    const self = this;

    if (useSessionStorage) {
      window.addEventListener('storage', (e) => {
        if (e.key === self.props.component.sessionStorageVariable) {
          if (
            self.props.component.customDefaultValue
            && self.props.component.customDefaultValue !== ''
          ) {
            try {
              const cDefaultValue = eval(self.props.component.customDefaultValue);
              if (cDefaultValue && (typeof cDefaultValue === 'string' || cDefaultValue instanceof String) && cDefaultValue !== '') {
                self.setValue(cDefaultValue);
              }
            } catch (err) {
              if (err instanceof SyntaxError) {
                console.log(err);
              }
            }
          }
        }
      }, false);
    } else if (value) {
      this.setValue(value?.value);
    } else {
      this.setValue(null);
    }
  }

  componentDidUpdate(prevProps) {
    const { props: { data } } = this;
    if (prevProps.data !== data) {
      this.setState({
        // eslint-disable-next-line react/no-unused-state
        data,
      });
    }
  }

  setValue = (v) => {
    const { props: { component: { label, reviewLabel, useReviewLabel }, onChange } } = this;
    const newValue = useReviewLabel ? { value: v, review: { label: reviewLabel } } : { value: v, review: { label } };
    this.setState({ value: newValue }, () => {
      // eslint-disable-next-line react/destructuring-assignment
      onChange(this.state.value);
    });
  };

  render() {
    const { state: { value }, props: { component: { hideCustomLabel, label, tooltip, suffix, prefix, placeholder, id, numbersOnly, tooltipTitle, isPhoneNumber, characterLimit }, disabled, intl } } = this;
    return (
      <>
        {!hideCustomLabel && (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <label style={{ marginRight: '3px' }}>
              <FormattedMessage id={label} defaultMessage={label} />
            </label>
            {tooltip !== '' && (
              <Tooltip id="textfield_tooltip" primary title={tooltipTitle ? intl.formatMessage({ id: `${tooltipTitle}`, defaultValue: `${tooltipTitle}` }) : ''}>
                <FormattedMessage id={tooltip} defaultMessage={tooltip} />
              </Tooltip>
            )}
          </div>
        )}
        <TextInput
          primary
          suffix={suffix}
          prefix={prefix}
          mask={isPhoneNumber ? '(999) 999-9999' : null}
          number={numbersOnly || false}
          disabled={disabled}
          placeholder={placeholder ? intl.formatMessage({ id: `${placeholder}`, defaultValue: `${placeholder}` }) : ''}
          defaultValue={value?.value ? value.value : ''}
          onChange={(v) => this.setValue(v)}
          id={`textfield_${id}`}
          maxLength={isPhoneNumber ? null : +characterLimit}
        />
      </>
    );
  }
};

const CustomTextFieldWithIntl = injectIntl(CustomTextField);

export default class TextFieldComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'Custom Text Field',
      icon: 'terminal',
      group: 'basic',
      documentation: '',
      schema: TextFieldComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customtextfield',
      },
      extend,
    );
  }

  /*
   * Defines the settingsForm when editing a component in the builder.
   */
  static editForm = CustomTextFieldSettingsForm;

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */
  attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);

    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <CustomTextFieldWithIntl
          inputRef={(refer) => {
            instance = refer;
          }}
          disabled={this._disabled}
          component={this.component} // These are the component settings if you want to use them to render the component.
          value={this.dataValue || this.dataForSetting} // The starting value of the component.
          data={this.data}
          onChange={this.updateValue} // The onChange event to call when the value changes.
        />
      </IntlProvider>,
      element,
      () => (this.reactInstance = instance),
    );
  }

  /**
   * Automatically detach any react components.
   *
   * @param element
   */
  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
